module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blogsingle"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "container_blog"
  }, [_c('div', {
    staticClass: "blog_bar_outer"
  }, [(_vm.props.title.rendered) ? _c('h3', {
    staticClass: "blogsingletitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "blog_barinner clearfix"
  }, [_c('h3', {
    staticClass: "blog_date_bar"
  }, [_c('span', [_vm._v("Date Published: ")]), _c('span', {
    staticClass: "date",
    domProps: {
      "innerHTML": _vm._s("<span>" + _vm.props.date.slice(5, 7) + "</span>/<span>" + _vm.props.date.slice(8, 10) + "</span>/<span>" + _vm.props.date.slice(0, 4) + "</span>")
    }
  })]), (_vm.props.better_featured_image) ? _c('div', {
    staticClass: "blog_imgsingle"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.better_featured_image.source_url
    }
  })]) : _vm._e(), (_vm.props.content.rendered) ? _c('div', {
    staticClass: "blog_full_content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  }) : _vm._e()])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89ca7fdc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/blog-post/blog-post.pug
// module id = 715
// module chunks = 1